<template>
  <div class="wrapper">
    <div class="content-wrapper">
      <div class="category-list">
        <div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="短网址">
              <el-input v-model="formInline.short_url" placeholder="短网址路径" clearable></el-input>
            </el-form-item>
            <el-form-item label="原链接">
              <el-input v-model="formInline.link" placeholder="原链接路径" clearable></el-input>
            </el-form-item>
            <el-form-item label="短链接备注">
              <el-input v-model="formInline.title" placeholder="短链接备注" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <header style="display: flex;">
          <h3>页面列表</h3>
          <el-button size="small" type="primary" class="add-btn"><a href="/short-url" style="color: #fff">添加短网址</a></el-button>
        </header>
        <!-- 分类列表 -->
        <el-table
            v-loading="tableLoading"
            :data="tableData"
            border
            style="width: 100%">

          <el-table-column
              prop="createTime"
              width="160"
              label="创建时间">
            <template slot-scope="scope">
              {{timeFormat(scope.row.create_at)}}
            </template>
          </el-table-column>

          <el-table-column
              width="280"
              prop="short_url"
              label="短网址">
            <template slot-scope="scope">
              {{scope.row.short_url}}
              <el-button @click="handleCopy" type="primary" class="copy-text" :data-clipboard-text="scope.row.short_url" size="mini">复制</el-button>
            </template>
          </el-table-column>

          <el-table-column
              width="400"
              prop="link"
              label="原网址">
            <template slot-scope="scope">
              {{scope.row.link}}
              <el-button @click="handleCopy" type="primary" class="copy-text" :data-clipboard-text="scope.row.link" size="mini">复制</el-button>
            </template>
          </el-table-column>

          <el-table-column
              prop="createTime"
              width="140"
              label="二维码">
            <template slot-scope="scope">
              <el-button v-popover:popCode>查看二维码</el-button>
              <el-popover
                  ref="popCode"
                  placement="right"
                  width="300"
                  trigger="hover">
                <img width="280px" height="280px" :src="'https://yytools-api.mockuai.com/api/test/page/qrcode?text='+scope.row.short_url" alt="">
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column
              prop="title"
              label="短链接备注">
          </el-table-column>

          <el-table-column
              label="操作"
              width="120"
          >
            <template slot-scope="scope">
<!--              <el-button @click="popDelBox(scope.row)" type="text"-->
<!--                         size="small">删除-->
<!--              </el-button>-->
              <el-button type="text" size="small"
                         @click="popAddBox('edit', scope.row)">编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagation" v-show="tableData.length > 0">
          <el-pagination
              layout="total, prev, pager, next"
              :total="page.totalCount"
              :page-size='page.pageSize'
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>


      <!-- 删除分类 -->
      <el-dialog
          :visible.sync="delBox"
          :before-close="handleDelCancel"
          title="删除页面"
          width="50%">
        <p class="title">确认删除该短网址！</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleDelCancel">取 消</el-button>
          <el-button type="primary" @click="handleDel">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 新增、编辑分类弹框 -->
      <el-dialog
          :visible.sync="dialogVisible"
          :before-close="handleCancel"
          width="50%">
        <div slot="title">{{ title }}</div>

        <el-form label-position="left" label-width="110px" ref="form" :model="LinkForm">
          <el-form-item label="短链接备注" prop="title">
            <el-input maxlength=50 minlength=1 v-model="LinkForm.title" placeholder="短链接备注"></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
                    <el-button @click="handleCancel">取 消</el-button>
                    <el-button type="primary" @click="addForm">确 定</el-button>
                </span>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import {Message, Loading} from 'element-ui';
import Common from "../picture/assets/scripts/common";
import Clipboard from 'clipboard';
export default {
  name: 'routerLink',
  data() {
    return {
      tableData: [],
      setTableData: [],
      dialogVisible: false,
      handleType: '', //操作分类的类型 'add'新增分类 'edit'编辑分类
      title: '',
      delBox: false,
      delData: {},
      tableLoading: true,
      formInline: {
        link: '',
        short_url: '',
        title: '',
      },

      LinkForm: {
        link: null,
        short_url: null,
        title: null,
      },
      page: {
        pageNumber: 1,
        pageSize: 20,
        pageCount: 20,
        currentPage: 0,
        totalCount: 0
      },
    }
  },
  mounted() {
    this.getLinkList('get');
  },
  methods: {
    handleCopy() {
      const clipboard = new Clipboard('.copy-text');
      clipboard.on('success', (e) => {
        Message.success({
          message: '复制成功！',
          type: 'info',
          center: true
        });
        clipboard.destroy();
      });
      clipboard.on('error', (e) => {
        Message.error({
          message: '复制失败！',
          type: 'info',
          center: true
        });
        clipboard.destroy();
      });
    },
    handleSizeChange: function (val) {
      console.log(val,1)
    },
    handleCurrentChange: function (val) {
      this.page.currentPage = val-1;
      this.getLinkList(val);
    },
    onSearch: function (){
      this.page.currentPage = 0;
      this.getLinkList('search');
    },
    addForm(){
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.handleLink();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //新增/编辑 页面配置
    handleLink() {
      let that = this;
      let handleType = this.handleType;
      if (handleType == 'add' || handleType == 'edit') {
        lib.tmsapi.post({
          api: 'api/test/short/add',
          data: this.LinkForm,
          success: (res) => {
            // 提示成功
            Message.success({
              message: '修改备注成功',
              type: 'info',
              center: true
            });
            this.resetForm();
            // 添加成功，刷新列表
            that.getLinkList('update');

            // 关闭弹框
            that.dialogVisible = false;
          },
        })
      }
    },
    // dialog取消按钮更改状态
    handleCancel: function () {
      this.dialogVisible = false;
      this.handleType = '';
      this.resetForm();
    },
    resetForm: function () {
      this.LinkForm = {
        link: null,
        title: null,
        short_url: null,
      }
    },
    // 点击新增/编辑弹框
    popAddBox: function (type, data) {
      if (!this.dialogVisible) {
        this.dialogVisible = true;
        this.handleType = type;
      }

      if (type == "edit") {
        this.title = "编辑短链接备注";
        this.LinkForm = data;
      }

    },

    // 获取分类列表
    getLinkList: function (type) {
      let params = {
        page: this.page.currentPage,
        count: this.page.pageSize,
      }
      params.short_url = this.formInline.short_url;
      params.link = this.formInline.link;
      params.title = this.formInline.title;
      lib.tmsapi.get({
        api: 'api/test/short/list',
        data: params,
        success: (res) => {
          if (res.data) {
            this.tableLoading = false;
            this.tableData = res.data || [];
            this.page.totalCount = res.total;
          }
        },
      })

    },

    // 点击删除弹框
    popDelBox: function (data) {
      if (!this.delBox) {
        this.delData = {...data};
        this.delBox = true;
      }
    }
    ,
    // 取消删除
    handleDelCancel: function () {
      this.delBox = false;
      this.delData = {};
    }
    ,
    // 删除一条分类
    handleDel: function (data) {
      let that = this;
      let linkId = this.delData.id;
      let params = {
        id: linkId
      };
      if (!linkId) {
        return false;
      }

      lib.tmsapi.post({
        api: 'api/test/short/del',
        data: params,
        success: (res) => {
          // 关闭弹框
          that.delBox = false;
          Message.success({
            message: '删除页面成功',
            type: 'info',
            center: true
          });
          // 添加成功，刷新列表
          that.getLinkList('update');
        },
      })

    }
    ,

    // 时间戳格式化
    timeFormat: function (date) {
      return Common.formatTime(date);
    },
  },
}
</script>
<style scoped>
.content-wrapper {
  padding: 20px;
  width: 100%;
}

.title {
  text-align: center;
  font-size: 16px;
}

.tips {
  font-size: 12px;
  padding-top: 10px;
  line-height: 18px;
  color: rgb(64, 158, 255);
}

.category-list header {
  display: flex;
  align-items: center;
  margin: 10px;
}

.category-list header h3 {
  flex: 1;
}

.category-manage {
  margin-top: 30px;
}

.category-manage header {
  display: flex;
  align-items: center;
  margin: 10px;
}

.category-manage small {
  font-size: 12px;
  color: #bbb;
  padding-left: 5px;
}

.category-manage .radio-button {
  margin: 0 10px 10px 10px;
  width: 150px;
  text-align: center;

}
</style>

